/* eslint-disable react/prop-types */
import React, { useState, useContext, useMemo, useEffect } from "react";
import config from "config";

import { Route, BrowserRouter, Switch, Redirect, useHistory } from "react-router-dom";
import Header from "./components/header/index";

import Login from "./components/login";
import ForgotPassword from "./components/forgotpassword";
import { Appcontext } from "../approuter";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import Error from "./components/error500";
import SessionTimeoutModal from "../components/SessionTimeoutModal";
import { sessionTimeout } from "../utils/sessionTimeout";
import { SECURITY_CONFIG } from "../config/security";
import User from "./components/user";
import UserProfile from "./components/User Profile/Profile";
import Dashboard from "./components/dashboard";
import Coin from "./components/Coin";
import Currency from "./components/Currency";
import Support from "./components/Support";
import TradingPair from "./components/TradingPair";
import P2ppair from "./components/P2P";
import Payment from "./components/Payment";
import Order from "./components/Order";
import Profile from "./components/profile/Profile";
import OrderDetail from "./components/OrderDetail";
import TradingPairDetail from "./components/TradingPairDetail";
import CoinDetail from "./components/CoinDetail/index.jsx";
import CoinNetwork from "./components/CoinNetwork";
import NetworkProfile from "./components/networkProfile/Profile";
import withdrawal from "./components/Withdrawl";
import FAQ from "./components/FAQ";
import Newsletter from "./components/Newsletter";
import Contact from "./components/Contact-us";
import BulkTradeRequests from "./components/BulkTradeRequests";
import Deposit from "./components/Deposit";
import Edd from "./components/Edd";
import UserProfileView from "./components/userProfile";
import Alert from "./components/Alert";
import WalletTrx from "./components/Wallet";
import WalletTr from "./components/wallet order";
import CoinNetworkForm from "./components/CoinNetwork/CoinNetworkForm";
import GullakPlans from "./components/GullakPlans";
import ThirdPartyStats from "./components/ThirdPartyStats";
import BalanceComparison from "./components/BalanceComparison";
import CoinDcxOrders from "./components/CoinDcxOrders";
import RoleManagement from "./components/RoleManagement";
import AdminUsersPage from "./components/AdminUsers";
import FireblocksSync from "./components/FireblocksSync";
import WalletTxReview from "./components/WalletTxReview";
import ComplianceConfigPage from "./components/ComplianceConfig";
import MaintenanceMode from "./components/MaintenanceMode";
import FeatureToggle from "./components/FeatureToggle";
import PolicyLinks from "./components/PolicyLinks";
import Logs from "./components/Logs";
import FinanceOverview from "./components/FinanceDashboard/Overview";
import WithdrawalFees from "./components/FinanceDashboard/WithdrawalFees";
import TDSReports from "./components/FinanceDashboard/TDSReports";
import INRDeposit from "./components/FinanceDashboard/INRDeposit";
import INRWithdraw from "./components/FinanceDashboard/INRWithdraw";
import FundingWalletTransactions from "./components/FinanceDashboard/FundingWalletTransactions";
import WalletTxDetail from "./components/FinanceDashboard/FundingWalletTransactions/WalletTxDetail";
import FiuMonthlyReports from "./components/FinanceDashboard/FiuMonthlyReports";
import WalletUserDetail from "./components/Wallet/UserDetail";
import AffiliateCodes from "./components/AffiliateCodes";
import KycConfigPage from "./components/KycConfig";
import ProtectedRoute from "./components/commoncomponent/ProtectedRoute";

const AppUniversal = function (props) {
  const [menu, setMenu] = useState(false);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState(SECURITY_CONFIG.SESSION.WARNING_TIME);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const { isAuth, setIsAuth } = useContext(Appcontext);

  const location = props?.location;

  useMemo(() => {
    if (
      location?.pathname == "/admin/login" ||
      location?.pathname == "/admin/forgotPassword" ||
      location?.pathname == "/admin/lockscreen" ||
      location?.pathname == "/admin/conform-email" ||
      location?.pathname == "/admin/404" ||
      location?.pathname == "/admin/500"
    ) {
      setIsAuth("admin");
    } else {
      setIsAuth("user");
    }
  }, [location]);

  const { loggedIn } = useSelector((state) => state.user);

  // Initialize session timeout tracking
  useEffect(() => {
    if (loggedIn) {
      // Initialize session timeout manager
      sessionTimeout.init(
        // Warning callback
        () => {
          setRemainingTime(SECURITY_CONFIG.SESSION.WARNING_TIME);
          setShowTimeoutModal(true);
        },
        // Logout callback
        () => {
          setShowTimeoutModal(false);
          // Redirect will be handled by sessionTimeout.handleLogout()
        }
      );

      return () => {
        // Cleanup on unmount
        sessionTimeout.cleanup();
      };
    }
  }, [loggedIn]);

  // Handle extend session
  const handleExtendSession = () => {
    sessionTimeout.extendSession();
    setShowTimeoutModal(false);
  };

  // Handle manual logout
  const handleManualLogout = () => {
    sessionTimeout.handleLogout();
    setShowTimeoutModal(false);
  };
  return (
    <BrowserRouter basename={`${config.publicPath}`}>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        {isAuth !== "" && (
          <Route
            render={(props) => (
              <Header {...props} onMenuClick={() => toggleMobileMenu()} />
            )}
          />
        )}

        {/* Session Timeout Warning Modal */}
        <SessionTimeoutModal
          show={showTimeoutModal}
          remainingTime={remainingTime}
          onExtend={handleExtendSession}
          onLogout={handleManualLogout}
        />

        <Switch>
          <Route path="/" exact render={() => <Redirect to="/admin/login" />} />
          <Route path="/admin/login" exact component={Login} />
          <Route
            path="/admin/forgotPassword"
            exact
            component={ForgotPassword}
          />
          {loggedIn ? (
            <>
              <ProtectedRoute path="/admin" exact component={Dashboard} module="dashboard" />
              <ProtectedRoute path="/admin/user" exact component={User} module="user" />
              <ProtectedRoute path="/admin/edd" exact component={Edd} module="user" />
              <ProtectedRoute path="/admin/alert" exact component={Alert} module="user" />
              <ProtectedRoute path="/admin/coin" exact component={Coin} module="coin" />
              <ProtectedRoute path="/admin/support" exact component={Support} module="support" />
              <ProtectedRoute path="/admin/tradingPair" exact component={TradingPair} module="trading-pair" />
              <ProtectedRoute path="/admin/currency" exact component={Currency} module="currency" />
              <ProtectedRoute path="/admin/p2p" exact component={P2ppair} module="p2p-support-coin" />
              <ProtectedRoute path="/admin/payment" exact component={Payment} module="payment-method" />
              <ProtectedRoute path="/admin/order" exact component={Order} module="order" />
              <ProtectedRoute path="/admin/wallet" exact component={WalletTrx} module="wallet" />
              <ProtectedRoute path="/admin/network" exact component={CoinNetwork} module="coin-network" />
              <ProtectedRoute path="/admin/fireblocks-sync" exact component={FireblocksSync} module="fireblocks-config" />
              <ProtectedRoute path="/admin/wallet-review" exact component={WalletTxReview} module="wallet-tx-review" />
              <ProtectedRoute path="/admin/compliance" exact component={ComplianceConfigPage} module="compliance-config" />
              <ProtectedRoute path="/admin/maintenance" exact component={MaintenanceMode} module="maintenance" />
              <ProtectedRoute path="/admin/feature-toggle" exact component={FeatureToggle} module="feature-toggle" />
              <ProtectedRoute path="/admin/logs" exact component={Logs} module="logs" />
              <ProtectedRoute path="/admin/order/:id" exact component={Profile} module="order" />
              <ProtectedRoute path="/admin/order-detail/:id" exact component={OrderDetail} module="order" />
              <ProtectedRoute path="/admin/trading-pair-detail/:id" exact component={TradingPairDetail} module="trading-pair" />
              <ProtectedRoute path="/admin/coin-detail/:id" exact component={CoinDetail} module="coin" />
              <ProtectedRoute path="/admin/wallet/:id" exact component={WalletTr} module="wallet" />
              <ProtectedRoute
                path="/admin/user/profile/:id"
                exact
                component={UserProfileView}
                module="user"
              />
              <ProtectedRoute
                path="/admin/network/new"
                exact
                component={CoinNetworkForm}
                module="coin-network"
              />
              <ProtectedRoute
                path="/admin/network/edit/:id"
                exact
                component={CoinNetworkForm}
                module="coin-network"
              />
              <ProtectedRoute
                path="/admin/network/:id"
                exact
                component={NetworkProfile}
                module="coin-network"
              />
              <Route path="/admin/user-profile" exact component={UserProfile} />
              <ProtectedRoute path="/admin/withdrawal" exact component={withdrawal} module="coin-buy-sell" />
              <ProtectedRoute path="/admin/deposit" exact component={Deposit} module="coin-buy-sell" />
              <ProtectedRoute path="/admin/faq" exact component={FAQ} module="home-faq" />
              <ProtectedRoute path="/admin/policy-link" exact component={PolicyLinks} module="policy-link" />
              <ProtectedRoute path="/admin/newsletter" exact component={Newsletter} module="news-letter" />
              <ProtectedRoute path="/admin/contact-us" exact component={Contact} module="contact-us" />
              <ProtectedRoute path="/admin/bulk-trade-request" exact component={BulkTradeRequests} module="bulk-trade-request" />
              <ProtectedRoute path="/admin/gullak-plans" exact component={GullakPlans} module="dashboard" />
              <ProtectedRoute path="/admin/third-party-stats" exact component={ThirdPartyStats} module="user" />
              <ProtectedRoute path="/admin/balance-comparison" exact component={BalanceComparison} module="wallet" />
              <ProtectedRoute path="/admin/coindcx-orders" exact component={CoinDcxOrders} module="order-transaction" />
              <ProtectedRoute path="/admin/roles" exact component={RoleManagement} module="role" />
              <ProtectedRoute path="/admin/admin-users" exact component={AdminUsersPage} module="role" />
              <ProtectedRoute path="/admin/finance/overview" exact component={FinanceOverview} module="finance-overview" />
              <ProtectedRoute path="/admin/finance/withdrawal-fees" exact component={WithdrawalFees} module="finance-withdrawal-fees" />
              <ProtectedRoute path="/admin/finance/tds" exact component={TDSReports} module="finance-tds" />
              <ProtectedRoute path="/admin/finance/inr-deposits" exact component={INRDeposit} module="finance-inr-deposit" />
              <ProtectedRoute path="/admin/finance/inr-withdrawals" exact component={INRWithdraw} module="finance-inr-withdraw" />
              <ProtectedRoute path="/admin/finance/funding-wallet-transactions" exact component={FundingWalletTransactions} module="finance-funding-wallet-tx" />
              <ProtectedRoute path="/admin/finance/funding-wallet-transactions/:id" exact component={WalletTxDetail} module="finance-funding-wallet-tx" />
              <ProtectedRoute path="/admin/finance/fiu-reports" exact component={FiuMonthlyReports} module="finance-fiu-reports" />
              <ProtectedRoute path="/admin/wallet/:userId/transactions" exact component={WalletUserDetail} module="wallet-detail" />
              <ProtectedRoute path="/admin/affiliate" exact component={AffiliateCodes} module="affiliate" />
              <ProtectedRoute path="/admin/kyc-config" exact component={KycConfigPage} module="kyc-config" />
            </>
          ) : (
            <Route exact component={Error} />
          )}
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default AppUniversal;
